export function camelCaseToDashCase(str: string): string {
	return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

export function dashCaseToCamelCase(str: string): string {
	return str.replace(/\W+(.)/g, (x, chr) => chr.toUpperCase());
}
